export const messages = {
  en: {
    goodsIn: {
      title: 'Goods Inbound',
      selectGoods: 'Select Goods',
      productImage: 'Product Image',
      productId: 'ID',
      productName: 'Name',
      specification: 'Specification',
      stock: 'Stock',
      quantity: 'Quantity',
      price: 'Price',
      operation: 'Operation',
      delete: 'Delete',
      totalAmount: 'Total Amount',
      selectSupplier: 'Select Supplier',
      addSupplier: 'Add Supplier',
      inboundNote: 'Inbound Note',
      inboundProcess: 'Inbound Process',
      cancel: 'Cancel',
      submit: 'Submit',
      requiredNote: 'Required, please fill in the inbound note',
      pleaseSelectGoods: 'Please select goods',
      pleaseSelectSupplier: 'Please select supplier',
      inputCorrectNumber: 'Please input correct number'
    },
    chooseProduct: {
      title: 'Select Product',
      productCategory: 'Product Category',
      productList: 'Product List',
      productCode: 'Product Code',
      productName: 'Product Name',
      spec: 'Specification',
      stock: 'Stock',
      cancel: 'Cancel',
      confirm: 'Confirm',
      pleaseSelectAtLeastOne: 'Please select at least one product'
    }
  },
  zh: {
    goodsIn: {
      title: '进货商品',
      selectGoods: '选择商品',
      productImage: '商品图片',
      productId: '编号',
      productName: '名称',
      specification: '规格',
      stock: '库存',
      quantity: '数量',
      price: '单价',
      operation: '操作',
      delete: '删除',
      totalAmount: '总金额',
      selectSupplier: '选择供应商',
      addSupplier: '新增供应商',
      inboundNote: '进货说明',
      inboundProcess: '进货流程',
      cancel: '取消',
      submit: '提交',
      requiredNote: '必填，请填写进货说明',
      pleaseSelectGoods: '请选择商品',
      pleaseSelectSupplier: '请选择供应商',
      inputCorrectNumber: '请输入正确的数字'
    },
    chooseProduct: {
      title: '选择商品',
      productCategory: '商品分类',
      productList: '商品列表',
      productCode: '商品编号',
      productName: '商品名称',
      spec: '规格',
      stock: '库存',
      cancel: '取消',
      confirm: '确定',
      pleaseSelectAtLeastOne: '请至少选择一件商品'
    }
  }
}